export default __webpack_public_path__ + "static/media/Webinar1.de5f3d3f.png";